import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import { forwardRef } from "react";
import { bgStyles, borderStyles, flexStyles, paddingStyles, pointerStyles, positionStyles } from "ui";
import styles from "./Dropdown.module.css";

type Props = ComponentProps["Generic"]["Menu"]["Dropdown"];

export const Dropdown = forwardRef<HTMLDivElement, Props>(({ children, className }: Props, ref) => {
  return (
    <div
      className={classNames(
        styles.dropdown,
        flexStyles.vert025,
        paddingStyles.p025,
        positionStyles.absolute,
        bgStyles.neutral0,
        borderStyles.neutral200,
        borderStyles.radius025,
        pointerStyles.noUserSelect,
        className,
      )}
      ref={ref}
    >
      {children}
    </div>
  );
});
